const disableFocusOnHiddenParents = () => {
    // Find all elements that have a hidden or invisible parent
    const focusableElements = document.querySelectorAll('a, button, input, select, textarea, [tabindex]');

    if(document.getElementById('1979')) {

    } else {
        focusableElements.forEach(el => {
            let parent = el;
            let isHidden = false;

            // Check if any parent is hidden or has display: none / visibility: hidden
            while (parent) {
                if ((parent.classList.contains('calc-content') && !parent.classList.contains('active')) || parent.hasAttribute('data-nosnippet') || parent.hasAttribute('hidden') || window.getComputedStyle(parent).display === 'none' || window.getComputedStyle(parent).visibility === 'hidden' || window.getComputedStyle(parent).opacity === 0) {
                    isHidden = true;
                    break;
                }
                parent = parent.parentElement;
            }

            // Disable focus if parent is hidden
            if (isHidden) {
                el.setAttribute('tabindex', '-1');
            } else {
                el.removeAttribute('tabindex');  // Enable focus if parent is visible
            }
        });
    }
}

const observer = new MutationObserver(disableFocusOnHiddenParents);

observer.observe(document.body, {
    attributes: true,
    subtree: true,
    attributeFilter: ['hidden', 'style', 'class']  // Watch for changes in `hidden` and `style` attributes
});

setTimeout(() => {
    disableFocusOnHiddenParents();
}, 2000);